import * as marietta from '../..';

export default class MiniMap {
    viewObj: HTMLCanvasElement = null;

    sourceDataInString;

    margin = 20;

    /**
     * コンストラクタ
     * @param {number} sx,sy,sw,sh - 元の画像の使用範囲
     * @param {number} type - 種類0：minimap 1:出力画像
     */
    constructor(floor: number, sx: number, sy: number, sw: number, sh: number, type: number = 0, imageWidth: number, imageHeight: number, cb: Function) {
      const destId = `topview_${String(floor)}`;

      // 表示するCanvasの作成
      const canvas = document.createElement('canvas');
      canvas.setAttribute('id', destId);
      canvas.style.position = 'fixed';
      canvas.style.cursor = 'pointer';

      const ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isPC) {
        canvas.width = imageWidth;
        canvas.height = imageHeight;
      } else if (ua.isTablet) {
        canvas.width = imageWidth * 2;
        canvas.height = imageHeight * 2;
        this.margin *= 2;
      } else {
        canvas.width = imageWidth * 2;
        canvas.height = imageHeight * 2;
      }

      // png/jpg 版
      // canvasに読み込む画像データを設定
      const self = this;
      const ctx = canvas.getContext('2d');
      const start = 120;
      {
        ctx.textAlign = 'center';
        ctx.fillStyle = '#ffffff';
        ctx.font = '16px sans-serif';
        const message: string = 'LOADING MAPS ...';
        ctx.fillText(message, 150, start);
        self.viewObj = canvas;

        // 1F以外なら非表示
        if (type === 0) {
          // ミニマップ表示領域に追加
          document.getElementById('topview').append(canvas);
          // 1F以外なら非表示
          if (floor !== 1) {
            self.viewObj.style.display = 'none';
          }
        }
      }
      marietta.webcad.WebCADGlobal.cadAPIManager.getMiniMapImage(floor, imageWidth, imageHeight, 0/* png */, (pngData: any) => {
        if (pngData) {
          const pngImage = new Image();
          pngImage.onload = function onload() {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(pngImage, 0, 0, canvas.width, canvas.height);
            self.viewObj = canvas;
            // 通信フィルタ
            marietta.webcad.WebCADGlobal.hideBusyStrict();
            cb();
          };
          pngImage.onerror = function onerror() {
            // canvas にエラー表示する.(TODO)
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.textAlign = 'center';
            ctx.fillStyle = '#ffffff';
            ctx.font = '16px sans-serif';
            ctx.fillText('MAP LOAD ERROR', 150, start);
            self.viewObj = canvas;

            // 通信フィルタ
            marietta.webcad.WebCADGlobal.hideBusyStrict();
            cb();
          };
          pngImage.src = `data:image/png;base64,${pngData}`;
          pngImage.crossOrigin = 'Anonymous';
          // 通信
          marietta.webcad.WebCADGlobal.showBusy(marietta.webcad.collection.WebCADMessages.getText('BUSY_CONNECTING'));

          if (ua.isIE || ua.isEdge) pngImage.crossOrigin = 'Anonymous'; // IEだとcanvas.toDataURLでSecurityErrorが発生するため
        } else {
          // canvas にエラー表示する.(TODO)
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.textAlign = 'center';
          ctx.fillStyle = '#ffffff';
          ctx.font = '16px sans-serif';
          ctx.fillText('MAP SERVER ERROR', 150, start);
          self.viewObj = canvas;
          cb();
        }
      });
    }
}
